import Chart, {ChartColor} from 'chart.js';

export interface DoughnutLabelConfig {
	labelProvider: LabelProvider;
	lastLabels: DoughnutChartLabel[];
	resizeStrategy: ResizeStrategy;
}

export interface Font {
	family?: string;
	lineHeight?: number;
	size?: number;
	style?: string;
	weight?: string;
	string?: string;
}

export interface Area {
	height: number;
	width: number;
}

export interface DoughnutChartLabel {
	text: string;
	font: Font;
	color?: ChartColor;
}

export enum ResizeStrategy {
	SHRINK,
	TRUNCATE
}

export type LabelProvider = (chart: Chart, index?: number, key?: string, value?: number) => DoughnutChartLabel[];
